import React from "react";
import ReactSeamlessScroll from "react-seamless-scroll";
import "../style/date.css";

const TablePlay = (props) => {
  const { subData } = props;
  return (
    <tr>
      <td className="rank">
        <p>
          <span>{subData.rank}</span>
        </p>
      </td>
      <td>{subData.number}</td>
      <td>{subData.name}</td>
      <td>{subData.totalSubScore}</td>
      <td>{subData.company}</td>
    </tr>
  );
};

const Broadcast = React.memo((props) => {
  const { playData } = props;
  return (
    <ReactSeamlessScroll>
      <table className="table-play">
        <tbody>
          {(playData || []).slice(3).map((item) => (
            <TablePlay subData={item} key={item.rank} />
          ))}
        </tbody>
      </table>
    </ReactSeamlessScroll>
  );
});

export default Broadcast;
